import { usePrivacy } from "providers/PrivacyProvider";
import CreateIcon from '../CreateIcon/CreateIcon';
import './CreateNav.scss';

/**
 * Component for rendering the nav list of create links.
 * 
 * Props: onClickCreateIcon
*/
const CreateNav = (props) => {
  const { privateMode } = usePrivacy();

  const onClickCreateIconHandler = () => {
    props.onClickCreateIcon();
  }

  return (
    <div className='create-nav'>
      <CreateIcon
        text='Album'
        to='/music/albums/create'
        onClick={onClickCreateIconHandler}
      />
      {privateMode &&
        <CreateIcon
          text='Day'
          to='/days/create'
          onClick={onClickCreateIconHandler}
        />
      }
      <CreateIcon
        text='Flash Card'
        to='/flash-cards/create'
        onClick={onClickCreateIconHandler}
      />
      {privateMode &&
        <CreateIcon
          text='Maxim'
          to='/maxims/create'
          onClick={onClickCreateIconHandler}
        />
      }
      <CreateIcon
        text='Note'
        to='/notes/create'
        onClick={onClickCreateIconHandler}
      />
      {privateMode &&
        <CreateIcon
          text='Page'
          to='/pages/create'
          onClick={onClickCreateIconHandler}
        />
      }
      {privateMode &&
        <CreateIcon
          text='Phrase'
          to='/phrases/create'
          onClick={onClickCreateIconHandler}
        />
      }
      <CreateIcon
        text='Recipe'
        to='/food/recipes/create'
        onClick={onClickCreateIconHandler}
      />
      <CreateIcon
        text='Task'
        to='/tasks/create'
        onClick={onClickCreateIconHandler}
      />
      <CreateIcon
        text='Wallpaper'
        to='/wallpapers/create'
        onClick={onClickCreateIconHandler}
      />
    </div>
  )
};

export default CreateNav;